export default __webpack_public_path__ + "static/media/main-bg.254fd077.png";